import imgValutec from 'assets/images/integrations/logos/img_valutec.png'

export const GIFT_CARD_PROVIDER_IMAGES: Record<string, string> = {
  valutec: imgValutec,
}
